"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.integrationQueries = exports.licenseQueries = exports.changeOrderRequestQueries = exports.budgetsQueries = exports.unitsOfMeasureQueries = exports.mailboxQueries = exports.submittalPackageQueries = exports.submittalQueries = exports.commonQueries = exports.RfiQueries = exports.rateTemplateQueries = exports.laborClassesQueries = exports.driveFilesQueries = exports.driveFolderQueries = exports.weatherQueries = exports.timeManagementQueries = exports.costCodeQueries = exports.locationTagQueries = exports.keywordQueries = exports.dailyReportsQueries = exports.projectsQueries = exports.fieldNotesQueries = exports.projectQueries = exports.userQueries = exports.authQueries = exports.permissionGroupQueries = exports.contactQueries = exports.companyQueries = exports.organizationQueries = void 0;
// export queries here
exports.organizationQueries = __importStar(require("./organizations"));
exports.companyQueries = __importStar(require("./companies"));
exports.contactQueries = __importStar(require("./contacts"));
exports.permissionGroupQueries = __importStar(require("./permissionGroup"));
exports.authQueries = __importStar(require("./auth"));
exports.userQueries = __importStar(require("./users"));
exports.projectQueries = __importStar(require("./projects"));
exports.fieldNotesQueries = __importStar(require("./fieldNotes"));
exports.projectsQueries = __importStar(require("./projects"));
exports.dailyReportsQueries = __importStar(require("./dailyReports"));
exports.keywordQueries = __importStar(require("./keywords"));
exports.locationTagQueries = __importStar(require("./locationTags"));
exports.costCodeQueries = __importStar(require("./costCodes"));
exports.timeManagementQueries = __importStar(require("./timeManagement"));
exports.weatherQueries = __importStar(require("./weather"));
exports.driveFolderQueries = __importStar(require("./driveFolders"));
exports.driveFilesQueries = __importStar(require("./driveFiles"));
exports.laborClassesQueries = __importStar(require("./laborClasses"));
exports.rateTemplateQueries = __importStar(require("./rateTemplates"));
exports.RfiQueries = __importStar(require("./rfi"));
exports.commonQueries = __importStar(require("./common"));
exports.submittalQueries = __importStar(require("./submittals"));
exports.submittalPackageQueries = __importStar(require("./submittalPackages"));
exports.mailboxQueries = __importStar(require("./mailbox"));
exports.unitsOfMeasureQueries = __importStar(require("./unitsOfMeasure"));
exports.budgetsQueries = __importStar(require("./budgets"));
exports.changeOrderRequestQueries = __importStar(require("./changeOrderRequests"));
exports.licenseQueries = __importStar(require("./licenses"));
exports.integrationQueries = __importStar(require("./integrations"));
